import { render, staticRenderFns } from "./RefIdList.vue?vue&type=template&id=5db2cb56"
import script from "./RefIdList.vue?vue&type=script&lang=js"
export * from "./RefIdList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports